/* status-panel.js */

<style>
section.section.status-panel {
  position: relative;
  /* margin-top: 1em !important; */
}

section.status-panel div.hidden {
  display: none;
}

section.status-panel > div {
  padding: .3em;
}

section.status-panel ul {
  margin: .2em 0 1em;
}

section.status-panel ul li {
  padding: .2em .4em;
  border: 1px solid transparent;
  border-radius: 5px;
}

section.status-panel ul.area-list .status-controls a {
  padding-bottom: 3px;
}

section.status-panel ul li.selected {
  border-color: var(--app-border);
  /* box-shadow: 2px 2px 20px rgb(0,0,255,.5); */
}

div.b-tabs section.tab-content {
  padding: 0;
}

div.b-tabs nav.tabs ul {
  margin-top: 0;
  margin-bottom: 0;
}

div.tab-item {
  position: relative;
}

section.status-panel ul.area-list {
  display: block;
  max-height: 6.5em;
  margin-bottom: .2em;
  overflow: auto;

  box-shadow:
    inset 0px 11px 8px -10px var(--app-border),
    inset 0px -11px 8px -10px var(--app-border);

}

div.level.control-bar {
  margin: 0 0 .5em;
}

div.save-status {
  text-align: center;
  border-radius: 5px;
  background-color: var(--app-panel-bg);
  position: absolute;
  top: -4em;

  width: 12em;
  left: 50%;
  transform: translateX(-50%);
}

div.save-status {
  font-size: .8em;
  line-height: .8em;
}

div.save-status span > span {
  font-size: .8em;
}

div.total-area {
  margin-right: .5em;
}

div.total-area span {
  font-size: 1.1em;
}
</style>

<template>
  <section class="section status-panel m-0 p-0" ref="statusPanel" v-bind:style="statusPanelStyles">
    <div class="box has-background-light">
      <ul class="area-list" v-if="areas.length">
        <status-panel-item
          v-for="area in areas"
          v-bind:key="area.indexID"
          :selected="(area.indexID == currentShape.indexID)"
          :value="area.convertedCalculated"
          :display-index="area.displayIndex"
          :distance-visible="area.distanceVisible"
          :view-mode="viewMode"
          :measure-suffix="measureSuffix"
          :label-text="area.labelText"
          :enable-cutout="true"
          :cutout="area.cutout"
          :show-measurement="showMeasurement"
          @mouseover="hoverShape(area)"
          @mouseup="hoverOffShape"
          @mouseout="hoverOffShape"
          @select="selectShape(area)"
          @delete="deleteShape(area)"
          @label-change="setShapeLabelText($event, area)"
          @distance-visible-change="toggleShapeDistanceVisible($event, area)"
          @cutout-change="toggleShapeCutout($event, area)"
          />
      </ul>
    </div>
  </section>
</template>

<script>
import { ref, computed, watch, onMounted, nextTick, getCurrentInstance } from 'vue'
import { useMainStore } from '@/stores/main'
import { useDialogsStore } from '@/stores/dialogs'
import { upperFirst } from 'lodash'
import StatusPanelItem from './StatusPanelItem.vue'

export default {
  components: {
    StatusPanelItem
  },
  props: {
    showMeasurement: {
      type: Boolean,
      default: false
    },
    viewMode: {
      type: String,
      default: 'view'
    }
  },
  emits: ['minimized', 'maximized', 'add-shape-click'],
  setup(props, { emit }) {
    const mainStore = useMainStore()
    const dialogsStore = useDialogsStore()
    const instance = getCurrentInstance()

    const statusPanel = ref(null)
    const currentTab = ref(0)
    const height = ref(0)
    const minimized = ref(true)

    // Computed
    const totalShapeCalculatedConverted = computed(() => mainStore.totalShapeCalculatedConverted)
    const currentShape = computed(() => mainStore.currentShape)
    const imperialStatus = computed(() => mainStore.imperialStatus)
    const measureSuffix = computed(() => mainStore.measureSuffix)
    const shapes = computed(() => mainStore.shapesWithConversions)
    const activeStatusTab = computed(() => mainStore.activeStatusTab)

    const activeStatusTabName = computed(() => {
      return upperFirst(mainStore.activeStatusTabName)
    })

    const areas = computed(() => {
      return shapes.value.filter(s => s.type == 'area')
    })

    const distances = computed(() => {
      return shapes.value.filter(s => s.type == 'distance')
    })

    const hide = computed(() => {
      return mainStore.mapDrag || mainStore.toolbarsHidden
    })

    const statusPanelStyles = computed(() => {
      return {
        display: (!mainStore.toolbarsHidden) ? 'block' : 'none'
      }
    })

    // Methods
    const toggleMinimized = (min) => {
      min = ((min === undefined) ? !minimized.value : min)
      minimized.value = !!min
      console.log(min)
      if (minimized.value) {
        emit('minimized')
        return
      }
      emit('maximized')
    }

    const selectShape = (shape) => {
      mainStore.setCurrentShape(shape)
    }

    const deleteShape = (shape) => {
      mainStore.deleteShape({ shape })
    }

    const setShapeLabelText = ($event, shape) => {
      mainStore.setShapeLabelText({
        shape,
        labelText: $event
      })
    }

    const toggleShapeCutout = (cutout, shape) => {
      mainStore.setShapeCutout({
        shape,
        cutout
      })
    }

    const toggleShapeDistanceVisible = (visible, shape) => {
      mainStore.setShapeDistanceVisible({
        shape,
        visible
      })
      if (shape.type == 'area' && visible == true) {
        dialogsStore.alert(0, 'Showing the edge lengths of an area <b>does not</b> affect the <i>Total Distance</i> calculation. Use the <i>Measure Distance</i> tool to utilize <i>Total Distance</i>.', {
          title: 'Important',
          type: 'is-warning'
        })
      }
    }

    const toggleMetric = (status) => {
      mainStore.setImperialState(!status)
    }

    const hoverShape = (shape) => {
      mainStore.hoverShape(shape)
    }

    const hoverOffShape = () => {
      mainStore.hoverShape(null)
    }

    const addLayer = () => {
      instance.proxy.$intro().exit()
      emit('add-shape-click')
    }

    // Watchers
    watch(shapes, (newShapes, oldShapes) => {
      oldShapes = oldShapes || []
      if (statusPanel.value) {
        setTimeout(() => {
          if (statusPanel.value) {
            height.value = statusPanel.value.offsetHeight
          }
        }, 500)
      }
    }, { immediate: true })

    watch(activeStatusTab, (newTab) => {
      if (newTab == null) return
      currentTab.value = newTab
    })

    watch(currentTab, (tab) => {
      // Only update store if the value actually changed
      if (mainStore.activeStatusTab !== tab) {
        mainStore.setActiveStatusTab(tab)
      }
    })

    watch(currentShape, (newShape, oldShape) => {
      if (oldShape && newShape.indexID !== oldShape.indexID) {
        if (newShape.indexID) {
          const newTab = (newShape.indexID && newShape.type == 'area') ? 0 : 1
          mainStore.setActiveStatusTab(newTab)
        }

        nextTick(() => {
          let selected = instance.proxy.$el.querySelector('ul.area-list li.selected')
          if (selected) selected.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          })
        })
      }
    })

    // Lifecycle
    onMounted(() => {
      toggleMinimized(minimized.value)
    })

    return {
      statusPanel,
      currentTab,
      height,
      minimized,
      totalShapeCalculatedConverted,
      currentShape,
      imperialStatus,
      measureSuffix,
      shapes,
      activeStatusTab,
      activeStatusTabName,
      areas,
      distances,
      hide,
      statusPanelStyles,
      toggleMinimized,
      selectShape,
      deleteShape,
      setShapeLabelText,
      toggleShapeCutout,
      toggleShapeDistanceVisible,
      toggleMetric,
      hoverShape,
      hoverOffShape,
      addLayer
    }
  }
}
</script>
